export default [
    {
        'id': 1457690400,
        'name': 'Stella Johnson',
        'thumb': 'http://i.pravatar.cc/150?img=5',
        'email': 'stella.johnson@example.com',
        'phone': '+1-215-659-7529',
        'designation': 'Agent',
        'selected': false,
        'starred': false,
        'frequently': true,
    }, {
        'id': 1457690401,
        'name': 'Garry Sobars',
        'thumb': 'http://i.pravatar.cc/150?img=11',
        'email': 'garry.sobars@example.com',
        'phone': '+1-215-745-7529',
        'designation': 'Agent',
        'selected': false,
        'starred': false,
        'frequently': true,
    },
    {
        'id': 1457690402,
        'name': 'Alex Dolgove',
        'thumb': 'http://i.pravatar.cc/150?img=16',
        'email': 'alex.dolgove@example.com',
        'phone': '+1-215-748-7855',
        'designation': 'Broker',
        'selected': false,
        'starred': false,
        'frequently': true,
    }, {
        'id': 1457690403,
        'name': 'Domnic Brown',
        'thumb': 'http://i.pravatar.cc/150?img=17',
        'email': 'domnic.brown@example.com',
        'phone': '+1-215-756-4579',
        'designation': 'Residential Broker',
        'selected': false,
        'starred': false,
        'frequently': true,
    }, {
        'id': 1457690404,
        'name': 'Kadir M',
        'thumb': 'http://i.pravatar.cc/150?img=56',
        'email': 'kadir.m@example.com',
        'phone': '+1-215-659-7586',
        'designation': ' Manager',
        'selected': false,
        'starred': false,
        'frequently': false,
    }, {
        'id': 1457690405,
        'name': 'John Smith',
        'thumb': 'http://i.pravatar.cc/150?img=12',
        'email': 'john.smith@example.com',
        'phone': '+1-215-876-8596',
        'designation': 'Agent',
        'selected': false,
        'starred': false,
        'frequently': false,
    }, {
        'id': 1457690406,
        'name': 'Domnic Harris',
        'thumb': 'http://i.pravatar.cc/150?img=18',
        'email': 'domnic.harris@example.com',
        'phone': '+1-215-785-3841',
        'designation': 'Agent',
        'selected': false,
        'starred': true,
        'frequently': false,
    }, {
        'id': 1457690407,
        'name': 'Jimmy Jo',
        'thumb': 'http://i.pravatar.cc/150',
        'email': 'jimmy.jo@example.com',
        'phone': '+1-215-456-5863',
        'designation': 'Agent',
        'selected': false,
        'starred': false,
        'frequently': false,
    }, {
        'id': 1457690408,
        'name': 'Jimmy Jon',
        'thumb': 'http://i.pravatar.cc/150?img=58',
        'email': 'jimmy.jon@example.com',
        'phone': '+1-215-278-4558',
        'designation': 'Agent',
        'selected': false,
        'starred': true,
        'frequently': false,
    }, {
        'id': 1457690409,
        'name': 'Jeson Born',
        'thumb': 'http://i.pravatar.cc/150?img=51',
        'email': 'jeson.born@example.com',
        'phone': '+1-215-286-7551',
        'designation': 'Broker',
        'selected': false,
        'starred': false,
        'frequently': false,
    }, {
        'id': 1457690410,
        'name': 'Steve Smith',
        'thumb': 'http://i.pravatar.cc/150?img=68',
        'email': 'steve.smith@example.com',
        'phone': '+1-215-586-5862',
        'designation': 'Agent',
        'selected': false,
        'starred': false,
        'frequently': false,
    },
    {
        'id': 1457690500,
        'name': 'Stella Johnson',
        'thumb': 'http://i.pravatar.cc/150?img=5',
        'email': 'stella.johnson@example.com',
        'phone': '+1-215-659-7529',
        'designation': 'Escrow Officer',
        'selected': false,
        'starred': false,
        'frequently': true,
    }, {
        'id': 1457690501,
        'name': 'Garry Sobars',
        'thumb': 'http://i.pravatar.cc/150?img=15',
        'email': 'garry.sobars@example.com',
        'phone': '+1-215-745-7529',
        'designation': 'Agent',
        'selected': false,
        'starred': false,
        'frequently': true,
    },
    {
        'id': 1457690502,
        'name': 'Alex Dolgove',
        'thumb': 'http://i.pravatar.cc/150?img=1',
        'email': 'alex.dolgove@example.com',
        'phone': '+1-215-748-7855',
        'designation': 'Title Company',
        'selected': false,
        'starred': false,
        'frequently': true,
    }, {
        'id': 1457690503,
        'name': 'Domnic Brown',
        'thumb': 'http://i.pravatar.cc/150?img=17',
        'email': 'domnic.brown@example.com',
        'phone': '+1-215-756-4579',
        'designation': 'Agent',
        'selected': false,
        'starred': false,
        'frequently': true,
    }, {
        'id': 1457690404,
        'name': 'Kadir M',
        'thumb': 'http://i.pravatar.cc/150?img=56',
        'email': 'kadir.m@example.com',
        'phone': '+1-215-659-7586',
        'designation': 'Manager',
        'selected': false,
        'starred': false,
        'frequently': false,
    }, {
        'id': 1457690505,
        'name': 'John Smith',
        'thumb': 'http://i.pravatar.cc/150?img=12',
        'email': 'john.smith@example.com',
        'phone': '+1-215-876-8596',
        'designation': 'Marketing',
        'selected': false,
        'starred': false,
        'frequently': false,
    }, {
        'id': 1457690506,
        'name': 'Domnic Harris',
        'thumb': 'http://i.pravatar.cc/150?img=18',
        'email': 'domnic.harris@example.com',
        'phone': '+1-215-785-3841',
        'designation': 'Transaction Manger',
        'selected': false,
        'starred': true,
        'frequently': false,
    }, {
        'id': 1457690507,
        'name': 'Jimmy Jo',
        'thumb': 'http://i.pravatar.cc/150?img=58',
        'email': 'jimmy.jo@example.com',
        'phone': '+1-215-456-5863',
        'designation': 'Accounting',
        'selected': false,
        'starred': false,
        'frequently': false,
    }, {
        'id': 1457690508,
        'name': 'Jimmy Jon',
        'thumb': 'http://i.pravatar.cc/150?img=59',
        'email': 'jimmy.jon@example.com',
        'phone': '+1-215-278-4558',
        'designation': 'Developer',
        'selected': false,
        'starred': true,
        'frequently': false,
    }, {
        'id': 1457690509,
        'name': 'Jeson Born',
        'thumb': 'http://i.pravatar.cc/150?img=51',
        'email': 'jeson.born@example.com',
        'phone': '+1-215-286-7551',
        'designation': 'Contractor',
        'selected': false,
        'starred': false,
        'frequently': false,
    }, {
        'id': 1457690510,
        'name': 'Steve Smith',
        'thumb': 'http://i.pravatar.cc/150?img=68',
        'email': 'steve.smith@example.com',
        'phone': '+1-215-586-5862',
        'designation': 'Agent',
        'selected': false,
        'starred': false,
        'frequently': false,
    }

]


// WEBPACK FOOTER //
// ./app/routes/contact/data/contactList.js